<template>
    <v-card>
        <v-card-title> {{ $t("Julkaisuasetukset") }} </v-card-title>

        <v-card-text>
            <v-tabs v-model="tab" outline>
                <v-tabs-slider></v-tabs-slider>
                <v-tab>{{ $t("Oletusuutiskuva") }}</v-tab>
                <v-tab>{{ $t("Avainsanojen hallinta") }}</v-tab>
                <v-tab>{{ $t("Pysyvät sivut") }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <div class="pa-4 mt-4">
                        <news-image v-model="newsImage" />
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div class="pa-4 mt-4">
                        <tag-management />
                    </div>
                </v-tab-item>
                <v-tab-item>
                    <div class="pa-4 mt-4">
                        <page-categories />
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-card-text>
    </v-card>
</template>

<script>
import { ref } from "@vue/composition-api";
import NewsImage from "./components/news-image.vue";
import TagManagement from "./components/tag-management.vue";
import PageCategories from "./components/page-categories.vue";

export default {
    components: {
        NewsImage,
        TagManagement,
        PageCategories,
    },
    setup() {
        const tab = ref(null);
        const newsImage = ref(null);
        const loading = ref(false);

        return {
            tab,
            newsImage,
            loading,
        };
    },
};
</script>

<style></style>
